<div class="apiKey-viewer">
    <key-viewer [key]="apiKey"
                [disabled]="disabled">
    </key-viewer>
    <nuc-button-secondary *ngIf="permissions.REFRESH_ACCESS_TOKEN | userIsAllowedTo" icon="nucicon_reset" nucTooltip="Refresh"
                          (click)="hasRefreshToken ? refreshApiKey.emit() : requestApiKey.emit()" [disabled]="disabled"></nuc-button-secondary>
</div>
